var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"image",attrs:{"src":_vm.src ? _vm.imageUrl : _vm.defaultImage,"alt":"","onerror":`this.onerror='';this.src='${_vm.defaultImage}'`},on:{"click":_vm.showImage}})
}
var staticRenderFns = []

export { render, staticRenderFns }